// src/pages/Order/Purchase Order/Purchase Order Entry/components/CreatePurchaseOrderForm.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Grid,
  DatePicker,
  Typography,
  Flex,
  Radio,
  Checkbox,
  Select,
  Drawer,
  Tooltip,
  Button,
} from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { getItemDisplayName } from "../../../../../utils";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import InputField from "../../../../../components/Input/Input";
import SearchListAutoComplete from "../../../../../components/SearchListAutoComplete";
import { QuestionCircleOutlined } from "@ant-design/icons";

import {
  fetchSuppliers,
  fetchItems,
  fetchTaxAccs,
  fetchDiscountAccs,

} from "../../../../../store/commonThunks/lookups";
import { fetchPurchaseOrderNumber, fetchTransportAccounts } from "../purchaseOrderThunk";
import {
  dateTimeFormat,
  formatToCompanyTimezone,
  getYearFromCompanyDate,
} from "../../../../../lib/functions";
import {
  resetPurchaseOrder,
  setSupplier,
  setEntryDate,
  setDueDate,
  addOrderRow,
  setTaxMode,
  calculateTotals,
  setConversionRate,
  setConversion,
  setTaxAcc,
  setDiscountAcc,
  setTransportAcc,
  setEditModeData,
  setPurchaseOrderId,
  setPurchaseOrderNo,
  setPayServiceCart,
  setFooterValues,
} from "../purchaseOrderSlice";
import { selectAuthInfo } from "../../../../Auth/authSelectors";
import { getCurrencyCodeWithName } from "../../../../../lib/currency";
import { convertCurrency } from "../../../../../utils";
import SupplierDrawer from "../../../../Purchase/Purchase/Supplier Entry/components/SupplierDrawer";
import { FRONTEND_APP_URL, postData } from "../../../../../apiservice/apis";
import useMigrationDate from "../../../../../hooks/useMigrationDate";


const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreatePurchaseOrderForm = ({ editId, institution }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [form] = useForm();



  const lookups = useSelector((s) => s.lookups);
  const authInfo = useSelector(selectAuthInfo);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [supplierDrawerOpen, setSupplierDrawerOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const currency = authInfo?.currency || "AED";

  const {
    supplierInfo,
    voucherNumber,
    paymentTerm,
    entryDate,
    dueDate,
    itemCart,
    taxMode,
    conversionRate,
  } = useSelector((s) => s.purchaseOrder);
  const entry = entryDate
    ? dayjs(entryDate).startOf("day")
    : null;

  const due = dueDate
    ? dayjs(dueDate).startOf("day")
    : null;

  const diffDays =
    entry && due ? due.diff(entry, "day") : 0;


  console.log("entryDate12349999999", diffDays);

  const isFieldHidden = (fieldKey, pageKey = "purchase_order_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey
    );
  };

const {disabledDate} = useMigrationDate();
  useEffect(() => {
    if (!editId) return; // create mode -> skip
    if (editId) {
      loadPurchaseOrderData(editId);
    }
  }, [editId]);

  const loadPurchaseOrderData = async (pur_o_id) => {
    try {


      const url = `/purchase/get-purchase-order-record-with-details`;
      const para = { pur_o_id: pur_o_id };

      const res = await postData(url, para);

      if (res === "Error: Request failed with status code 401") {
        sessionStorage.clear();
        window.location.reload();
        window.location.href = `${FRONTEND_APP_URL}`;
        return;
      }

      if (res?.data && res.data.length > 0) {
        const data = res.data[0];
        const details = data.details || [];
        const services = data.otherServiceTrans || [];

        // ✅ Transform services data for payServiceCart
        const transformedServices = services.map((service, index) => ({
          key: `service_${index}`,
          to_acc_id: service.to_acc_id,
          to_acc_name: service.to_acc_name,
          acc_type_id: service.acc_type_id,
          tran_amount: parseFloat(service.tran_amount) || 0,
          date: data.created_date,
        }));

        // ✅ Calculate total service charge
        const totalServiceCharge = transformedServices.reduce(
          (sum, service) => sum + (service.tran_amount || 0),
          0
        );

        let dueDate = null;
        let fdate = formatToCompanyTimezone(data.created_date);
        const entry = dayjs(fdate, "DD-MM-YYYY HH:mm:ss");

        if (
          data &&
          data.created_date &&
          data.due_date !== null &&
          data.due_date !== undefined && data.due_date != 0
        ) {

          if (entry.isValid()) {
            dueDate = entry
              .add(Number(data.due_date), "day")
              .format("YYYY-MM-DD");

          }
        }

        // Transform data following sales pattern
        const transformedData = {
          supplierInfo: {
            acc_id: data.acc_id,
            acc_name: data.acc_name,
            institution_name: data.institution_name,
            address: data.address,
            contact_no: data.contact_no,
            email_address: data.email_address,
            acc_code: data.acc_code,
            display_text: `${data.acc_name} - ${data.acc_code}`,
          },
          itemCart: details.map((item, index) => ({
            key: Date.now() + index,
            item_id: item.item_id,
            product: item.item_name,
            product_display: getItemDisplayName(item),
            quantity: parseFloat(item.item_qty) || 0,
            rate: parseFloat(item.item_rate) || 0,
            tax_per: parseFloat(item.item_tax_per) || 0,
            discount: parseFloat(item.item_discount_per) || 0,
            discountAmt: parseFloat(item.item_discount) || 0,
            discountMode: item.discount_mode || "percent",
            bonus: false,
            item_description: item.item_description || "",
            showDescription: !!item.item_description,
            warehouse_id: item.warehouse_id || "0",
            line_total: parseFloat(item.item_total) || 0,
            unit_id: item.unit_id,
            unit_symbol: item.unit_symbol,
            per_conversion: parseFloat(item.per_conversion) || 1,
            conversion: parseFloat(item.conversion) || 1,
            units: item.units || [],
            pur_d_id: item.pur_d_id,
          })),
          footerValues: {
            subtotal: parseFloat(data.sub_total) || 0,
            totalTax: parseFloat(data.total_tax) || 0,
            grandTotal: parseFloat(data.total_amount) || 0,
            total_discount: parseFloat(data.total_discount) || 0,
            total_transport_cost: parseFloat(data.total_transport_cost) || 0,
            description: data.narration || "",
            paidAmount: 0,
            dueAmount: parseFloat(data.total_amount) || 0,
            discountPct: parseFloat(data.total_discount_per) || 0,
            discountAmt: parseFloat(data.total_discount) || 0,
            discountMode: data.total_discount_mode || "percent",
            taxPct: parseFloat(data.total_tax_per) || 0,
            serviceCharge: totalServiceCharge || parseFloat(data.other_service_cost) || 0,
            payServiceCart: transformedServices,
            paymentTermsDescription: data.payment_terms_description || "",
            showTermsConditions: data.show_terms_conditions === "yes",
          },

          narration: data.narration || "",
          voucherNumber: data.pur_order_no,

          entryDate: entry,
          dueDate: dueDate || null,
          tagFieldId: null,
          pur_o_id: data.pur_o_id,
          paymentTerm: data.payment_terms || "Immediate",
          taxMode: data.is_cal_type === "individual" ? "on_item" : "on_total",
          selectedDiscountAcc: data.discount_acc_id && data.discount_acc_name ? {
            acc_id: data.discount_acc_id,
            acc_name: data.discount_acc_name,
          } : null,
          selectedTaxAcc: data.tax_acc_id && data.tax_acc_name ? {
            acc_id: data.tax_acc_id,
            acc_name: data.tax_acc_name,
          } : null,
          selectedTransportAcc: data.transport_acc_id !== "0" && data.transport_acc_name ? {
            acc_id: data.transport_acc_id,
            acc_name: data.transport_acc_name,
          } : null,
          conversionRate: parseFloat(data.conversion_rate) || 0,
          conversionCurrency: data.conversion_currency || null,
        };
        if (data.other_service_cost) {
          transformedData.footerValues.addExpenses = true;
        }
        dispatch(setPurchaseOrderNo(data.pur_order_no));
        // Set the data to Redux state
        dispatch(setPurchaseOrderId(data.pur_o_id));
        dispatch(setEditModeData(transformedData));

        // if (transformedServices.length > 0) {
        //   dispatch(setPayServiceCart(transformedServices));
        // }

        dispatch(calculateTotals({ authInfo }));
        // Update form fields
        if (transformedData.supplierInfo) {
          form.setFieldValue("search_supplier", {
            value: transformedData.supplierInfo.acc_name,
            label: transformedData.supplierInfo.acc_name,
            display_text: transformedData.supplierInfo.display_text,
            raw: transformedData.supplierInfo,
          });
        }

        if (transformedData.entryDate) {
          form.setFieldValue("entry_date", dayjs(
            transformedData.entryDate,

          ));
        }

        if (transformedData.dueDate) {
          form.setFieldValue("due_date", dayjs(transformedData.dueDate));
        }

        // Show currency conversion if applicable
        if (transformedData.conversionRate > 0) {
          SetIsConvertCurrencyShow(true);
        }


      } else {

        navigate("/order/purchase");
      }
    } catch (error) {
      console.error("Edit Load Failed:", error);
      navigate("/order/purchase");
    }
  };

  useEffect(() => {
    if (editId) return;
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchPurchaseOrderNumber(year));
  }, [entryDate]);

  useEffect(() => {
    dispatch(fetchSuppliers("")); // load supplier list
    dispatch(fetchItems("")); // load items list
    dispatch(fetchTaxAccs()).then((res) => {
      if (res.payload?.length > 0) dispatch(setTaxAcc(res.payload[0]));
    });
    dispatch(fetchDiscountAccs()).then((res) => {
      if (res.payload?.length > 0) dispatch(setDiscountAcc(res.payload[0]));
    });
    dispatch(fetchTransportAccounts()).then((res) => {
      if (res.payload?.length > 0) dispatch(setTransportAcc(res.payload[0]));
    });
  }, [dispatch]);

  const handleSupplierSelect = (sup) => {
    if (sup === "add_new") {
      setSupplierDrawerOpen(true);
      return;
    }

    if (sup) {
      dispatch(setSupplier(sup));
      if (itemCart.length === 0) {
        const newRow = {
          key: Date.now(),
          item_id: null,
          product: "",
          quantity: 1,
          rate: 0,
          tax_per: 0,
          discount: 0,
          bonus: false,
          item_description: "",
          showDescription: false,
        };
        dispatch(addOrderRow(newRow));
        dispatch(
        setFooterValues({
          paymentTermsDescription:
            institution?.purchase_order_payment_terms || "",
          showTermsConditions: true,
        })
      );
      }
    } else {
      // reset form if no supplier
      dispatch(resetPurchaseOrder());
    }
  };

  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={3} style={{ margin: 0, marginBottom: "15px" }}>
          Purchase Order
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>
      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Supplier Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Search Supplier" required>
              <SearchListAutoComplete
                entityType="supplier"
                placeholder="Supplier"
                optionsList={lookups.suppliers.map((s) => ({
                  sale_id: s.acc_id,
                  display_text: [s.acc_name, s.contact_no, s.institution_name]
                    .filter(Boolean)
                    .join(" - "),
                  raw: s,
                }))}
                value={
                  supplierInfo?.acc_id
                    ? {
                      value: supplierInfo.acc_name,
                      label: supplierInfo.acc_name,
                      display_text: supplierInfo.acc_name,
                      raw: supplierInfo,
                    }
                    : null
                }
                onSelect={(obj) =>
                  handleSupplierSelect(obj?.raw ? obj?.raw : obj)
                }
                showAddNew={true}
              />
            </Form.Item>
            <Form.Item label="Institution Name">
              <InputField value={supplierInfo?.institution_name} disabled />
            </Form.Item>
            <Form.Item label="Supplier Address">
              <InputField value={supplierInfo?.address} disabled />
            </Form.Item>
            <Form.Item label="Contact No">
              <InputField value={supplierInfo?.contact_no} disabled />
            </Form.Item>
                <Form.Item label="Discount">
                  <Radio.Group
                    options={[
                      { label: "On Total", value: "on_total" },
                      { label: "On Individual Item", value: "on_item" },
                    ]}
                    onChange={(e) => {
                      dispatch(setTaxMode(e.target.value));
                      dispatch(calculateTotals({ authInfo }));
                    }}
                    value={taxMode}
                  />
                </Form.Item>


          </Flex>

          {/* Order Info */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="PO No">
              <InputField
                value={voucherNumber || ""}
                disabled
                data-testid="order-no"
              />
            </Form.Item>
            <Form.Item label="Entry Date" required>
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) =>
                  dispatch(setEntryDate(d ? d.toISOString() : null))
                }
                format={dateTimeFormat}
                                  disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item label="Payment Term">
              <InputField value={paymentTerm || ""} disabled />
            </Form.Item>
            <Form.Item label="Due Date">
              <DatePicker
                style={{ width: "100%" }}
                value={dueDate ? dayjs(dueDate) : null}
                onChange={(d) =>
                  dispatch(setDueDate(d ? d.toISOString() : null))
                }
                format="DD/MM/YYYY"
              />
            </Form.Item>
            {!isFieldHidden("Convert Currency") && (
              
              <Form.Item>
                <Checkbox
                  onChange={(e) => {
                    const checked = e.target.checked;

                    SetIsConvertCurrencyShow(checked);

                    if (!checked) {
                      // 🔥 Clear conversion using Redux
                      dispatch(setConversionRate(0));
                      dispatch(setConversion(null, "conversion_currency"));
                    }
                  }}
                >
                  Convert Currency
                </Checkbox>
              </Form.Item>
            )}
          </Flex>
        </Flex>
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {isConvertCurrencyShow && (
            <>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Choose Currency">
                  <Select
                    showSearch
                    placeholder="Select Currency"
                    style={{ minWidth: 200 }}
                    options={getCurrencyCodeWithName().map((c) => ({
                      value: c.code,
                      label: `${c.currency} (${c.code})`,
                    }))}
                    onChange={async (toCurrency) => {
                      const rate = await convertCurrency(currency, toCurrency);

                      if (rate) {
                        // store conversion rate once for use in InvoiceTable
                        // handleFooterChange(rate, "conversion_rate");
                        dispatch(
                          setConversion(toCurrency, "conversion_currency")
                        );
                        dispatch(setConversionRate(rate));
                        // setConversionRate(rate);
                      }
                    }}
                  />
                </Form.Item>
              </Flex>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Conversion Rate">
                  <InputField value={conversionRate} disabled />
                </Form.Item>
              </Flex>
            </>
          )}
        </Flex>
      </Form>

      <SupplierDrawer
        open={supplierDrawerOpen}
        onClose={() => setSupplierDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(supplier) => {
          if (!supplier) return;

          // 1️⃣ close drawer first
          setSupplierDrawerOpen(false);

          //  Update Redux
          dispatch(setSupplier(supplier));
          // dispatch(fetchPurchaseEntryNumber());
          dispatch(fetchSuppliers());

          //  Update form field
          // form.setFieldValue("search_supplier", {
          //   value: supplier.acc_name,
          //   label: supplier.acc_name,
          //   display_text: supplier.acc_name,
          //   raw: supplier,
          // });

          // if no rows → add first empty row
          if (itemCart.length === 0) {
            dispatch(
              addOrderRow({
                key: Date.now(),
                item_id: null,
                product: "",
                quantity: 1,
                rate: 0,
                tax_per: 0,
                discount: 0,
                bonus: false,
                item_description: "",
                showDescription: false,
              })
            );
          }
          //  Load dependent data (same as normal select)
          dispatch(fetchItems(supplier?.party_type || false));
        }}
      />
    <Drawer
      title="Purchase Order Help"
      open={helpOpen}
      onClose={() => setHelpOpen(false)}
      width={420}
      styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
    >
      <div style={{ lineHeight: 1.8 }}>
        <h2
          style={{
            fontSize: "18px",
            fontWeight: 600,
            marginBottom: "12px",
            marginLeft: "8px",
          }}
        >
          Purchase Order Entry
        </h2>

        <p
          style={{
            color: "#555",
            marginBottom: "16px",
            marginLeft: "8px",
          }}
        >
          The Purchase Order Entry module in FORTHERP is used to create and
          manage purchase orders with suppliers. It helps maintain accurate
          procurement records and supports seamless integration with
          inventory and accounts.
        </p>

        <div
          style={{
            background: "#f5f5f5",
            padding: "14px",
            borderRadius: "8px",
            marginBottom: "16px",
          }}
        >
          <strong>Steps to Create Purchase Order</strong>

          <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>Open <strong>Order → Purchase Order</strong></li>
            <li>Select or create the supplier</li>
            <li>Verify PO number and entry date</li>
            <li>Add products/items with quantity and pricing</li>
            <li>Apply discounts, or transport charges if required</li>
            <li>Set payment terms and due date</li>
            <li>Review order totals and supplier details</li>
            <li>Click <strong>Save</strong> to create the purchase order</li>
          </ol>
        </div>

        <div
          style={{
            background: "#fafafa",
            border: "1px solid #eee",
            padding: "14px",
            borderRadius: "8px",
          }}
        >
          <strong>Important Notes</strong>

          <ul
            style={{
              paddingLeft: "18px",
              marginTop: "10px",
              color: "#666",
            }}
          >
            <li>Supplier selection is required before saving.</li>
            <li>Purchase totals are affected by VAT and discount settings.</li>
            <li>Currency conversion can be enabled if required.</li>
            <li>Saved purchase orders can later be converted into purchases.</li>
          </ul>
        </div>
      </div>
    </Drawer>
    </div>
  );
};

export default CreatePurchaseOrderForm;
